import {
  BasicButton,
  NavBar,
  NavBarMenu,
  NavBarMenuItem,
} from "@mindsight/einstein";
import { Button, Dropdown } from "antd";
import { Header, Loader } from "semantic-ui-react";
import React from "react";

import { DownOutlined } from "@ant-design/icons";
import { AxiosEmployeeAPI } from "../../../employees/Api";
import { ErrorSegment } from "../ErrorSegment";
import { ToastId } from "../../ToastIds";
import { TopMenuContainer } from "./styles";
import mindsightLogo from "/mindsightLogo.png";
import { toast } from "react-toastify";
import { useAsync } from "react-async";
import { useAuth } from "../../../utils/Auth";
import { useLocation } from "react-router-dom";
import { useSettings } from "../../../utils/Settings";

const UserItem = ({ employee, userId, ...props }) => {
  if (employee) {
    return (
      <Header style={{ fontSize: "1rem", margin: 0 }} {...props}>
        {employee?.email || employee.employee_code}
        <Header.Subheader>{employee.name} </Header.Subheader>
      </Header>
    );
  }
  return null;
};

const UserMenu = ({ user, authorizedEmployees }) => {
  const { reload } = useAuth();
  const { run, error } = useAsync({
    deferFn: async (args, props, controller) => {
      await AxiosEmployeeAPI.changeActiveEmployee(args, props, controller);
      reload();
    },
  });

  const handleActiveEmployeeChange = (employee) => {
    run({ employee_code: employee.employee_code });
  };

  const selected = user.active_employee ? user.active_employee : {};

  const employeeChangeOptions = authorizedEmployees.filter(
    (e) => !selected || e.id !== selected.id,
  );

  if (error) {
    toast.error(
      "Não foi possível trocar o funcionário ativo!",
      ToastId.ERROR_ACTIVE_EMPLOYEE,
    );
  }
  if (employeeChangeOptions?.length === 0) {
    return (
      <Button disabled>
        Visão de:{" "}
        {user.active_employee?.email || user.active_employee.employee_code}
      </Button>
    );
  }

  const items = employeeChangeOptions.map((e) => ({
    key: e.id,
    label: (
      <div onClick={() => handleActiveEmployeeChange(e)}>
        <UserItem employee={e} userId={user.id} />
      </div>
    ),
  }));

  return (
    <Dropdown menu={{ items }}>
      <Button className="btn-top-menu">
        Visão de:{" "}
        {user.active_employee?.email || user.active_employee.employee_code}
        <DownOutlined />
      </Button>
    </Dropdown>
  );
};

const UserMenuData = () => {
  const { user } = useAuth();

  const {
    data: authorizedEmployees,
    isPending,
    error,
  } = useAsync({
    promiseFn: AxiosEmployeeAPI.getAuthorizedEmployees,
  });

  if (isPending) return <Loader active />;
  if (error) return <ErrorSegment message={error.message} />;
  if (user && authorizedEmployees)
    return <UserMenu user={user} authorizedEmployees={authorizedEmployees} />;

  return null;
};

export const TopMenu = () => {
  const { pathname } = useLocation();
  const { data: settings, isFetching: isPending, error } = useSettings();
  const firstNameFromPathname = pathname.split("/")[1];

  const menuItemData = [
    { key: "minha_equipe", to: "/minha_equipe", label: "Início" },
    { key: "pendencias", to: "/pendencias", label: "Pendências" },
    { key: "funcionarios", to: "/funcionarios", label: "Funcionários" },
    { key: "cargos", to: "/cargos", label: "Cargos" },
    { key: "areas", to: "/areas", label: "Áreas" },
  ];

  if (isPending) return <Loader active data-testid="top-menu-loader" />;
  if (error) return <ErrorSegment message={error.message} />;

  const companyLogo =
    settings.find((setting) => setting.key === "LOGO_IMAGE")?.value ||
    mindsightLogo;
  const analisesLink = settings.find(
    (setting) => setting.key === "ANALISES_INTEGRATION",
  ).value;
  const analisesName = settings.find(
    (setting) => setting.key === "ANALISES_NAME",
  ).value;

  return (
    <TopMenuContainer>
      <NavBar logo={companyLogo}>
        <NavBarMenu>
          {menuItemData.map((item) => (
            <NavBarMenuItem
              url={item.to}
              key={item.key}
              selected={firstNameFromPathname === item.key}
            >
              {item.label}
            </NavBarMenuItem>
          ))}
          <NavBarMenuItem key="viewOf">
            <UserMenuData />
          </NavBarMenuItem>
          <NavBarMenuItem key="linkToAnalises">
            <BasicButton colorTheme="primary" href={analisesLink}>
              {analisesName}
            </BasicButton>
          </NavBarMenuItem>
        </NavBarMenu>
      </NavBar>
    </TopMenuContainer>
  );
};
